<template>
     <svg class="svg-inline--fa fa-w-16" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><path d="M2 9H0v5h5v-2H2V9ZM0 5h2V2h3V0H0v5Zm12 7H9v2h5V9h-2v3ZM9 0v2h3v3h2V0H9Z" fill="currentColor" fill-rule="evenodd" class="fill-000000"></path></svg>
</template>